import { Box, Divider, Stack, TextField, Typography } from "@mui/material";

export default function DeclarationSignature({
    principalForm,
    setPrincipalForm
}) {
    return (
        <Stack spacing={2}>
            {/* ================= Remarques finales ================= */}
            <Typography variant="h6">Remarques finales</Typography>
            <Box sx={{ my: 2 }}>
                <Typography sx={{ mb: 2 }}>
                    Vous devrez aussi fournir des informations concernant votre conjoint et vos enfants, qu’ils vous accompagnent ou non.
                </Typography>
                <Typography sx={{ mb: 2 }}>
                    Votre conjoint peut remplir sa propre déclaration d’intérêt et inclure votre numéro dans sa section « Informations personnelles », et vice versa.
                </Typography>
                <Typography sx={{ mb: 2 }}>
                    Un enfant de moins de 18 ans ne peut pas remplir sa propre déclaration d’intérêt.
                </Typography>
                <Typography sx={{ mb: 2 }}>
                    Vous pouvez mettre à jour votre déclaration d’intérêt à tout moment.
                </Typography>
                <Typography>
                    Documents utiles :
                </Typography>
                <Box sx={{ pl: 3 }}>
                    <Typography>- Passeports</Typography>
                    <Typography>- Résultats des tests de français</Typography>
                    <Typography>- Offre d’emploi validée</Typography>
                    <Typography>- Diplômes secondaires et postsecondaires</Typography>
                    <Typography>- Attestations d’emploi (5 dernières années)</Typography>
                    <Typography>- Évaluation d’une autorité réglementaire (si applicable)</Typography>
                    <Typography>- Renseignements personnels de votre conjoint(e) (si applicable)</Typography>
                </Box>
            </Box>

            {/* ================= Déclaration ================= */}
            <Divider sx={{ my: 3 }} />
            <Typography variant="h6">Déclaration</Typography>
            <Stack spacing={2}>
                <Box sx={{ my: 2 }}>
                    <Typography sx={{ mb: 2 }}>
                        Je déclare et confirme avoir fourni de manière véridique et complète toutes les informations requises dans le présent questionnaire d’évaluation.
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        J’autorise et consens à ce que MV utilise ces informations pour la création de mon profil <b>Arrima</b>.
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        Je comprends clairement que toute information fausse, inexacte, incomplète ou trompeuse peut entraîner une discordance entre le score Arrima et la situation réelle.
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        J’assume volontairement l’entière responsabilité de toute conséquence défavorable en résultant (y compris, sans s’y limiter, un refus de demande ou la résiliation du contrat) et j’accepte que votre société traite mes droits de service et les frais correspondants conformément aux dispositions du contrat.
                    </Typography>
                </Box>

                <TextField
                    required
                    label="Signature :"
                    value={principalForm.declarationSignature}
                    onChange={(e) => setPrincipalForm(prev => ({ ...prev, declarationSignature: e.target.value }))}
                />

                <TextField
                    required
                    type="date"
                    label="Date :"
                    slotProps={{
                        inputLabel: { shrink: true }
                    }}
                    value={principalForm.declarationDate}
                    onChange={(e) => setPrincipalForm(prev => ({ ...prev, declarationDate: e.target.value }))}
                />
            </Stack>
        </Stack>
    );
}